export const documentationFilterType = {
  Evaluation: 0,
  Assessment: 1,
  Both: 2,
}
